import React from 'react';
import loader from '../../../assets/Heartbeat_loader.gif';

export default function Loader() {
  return (
    <div style={styles.container}>
      <img src={loader} alt="Loading..." />
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  },
};
